import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-label-check',
  templateUrl: './label-check.component.html',
  styleUrls: ['./label-check.component.scss']
})
export class LabelCheckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
